var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mail a Check "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.31371 6.75714C9.66362 6.22426 10.6283 5.64905 11.3601 5.70651L20.595 5.48109C21.4786 5.55047 22.3243 6.10582 22.7392 6.88899L23.8285 9.19982",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1494",
    d: "M10.1055 9.26367H25.3781C25.434 9.26367 25.4874 9.28709 25.5253 9.32825L28.579 12.6469C28.6129 12.6838 28.6318 12.7321 28.6318 12.7823V16.6847C28.6318 17.237 28.1841 17.6847 27.6318 17.6847H14.2897",
    stroke: "#20242E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M15.5858 12.1259C15.1207 12.1259 14.7437 12.4275 14.7437 12.7996C14.7437 13.1717 15.1207 13.4733 15.5858 13.4733C16.0508 13.4733 16.4279 13.7749 16.4279 14.147C16.4279 14.519 16.0508 14.8206 15.5858 14.8206M15.5858 12.1259C15.8975 12.1259 16.1696 12.2614 16.3152 12.4627M15.5858 12.1259V11.7891M15.5858 14.8206L15.5858 15.1575M15.5858 14.8206C15.2741 14.8206 15.0019 14.6852 14.8563 14.4838",
    stroke: "#0E5CF4",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1495",
    d: "M25.2632 9.26367V12.4321C25.2632 12.5426 25.3527 12.6321 25.4632 12.6321H28.6316",
    stroke: "#20242E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 118",
    d: "M22.7368 12.6309C20.8067 12.6309 18.5263 12.6309 18.5263 12.6309",
    stroke: "#0E5CF4",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 119",
    d: "M21.0527 14.3164C19.9526 14.3164 18.5264 14.3164 18.5264 14.3164",
    stroke: "#0E5CF4",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_3",
    d: "M17.0016 17.883L15.4615 17.9129C14.5543 17.9305 13.7391 17.3952 13.3947 16.5558L12.81 15.1307M26.0718 17.7734L15.3206 17.9137C14.5044 17.9243 13.7636 17.4379 13.449 16.6847L9.30551 6.76412L3.45131 15.6021C2.84014 16.5247 3.0945 17.7684 4.01886 18.377L17.5379 27.2781C18.4666 27.8895 19.7156 27.6261 20.3184 26.6918L26.0718 17.7734Z",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 190",
    d: "M12.6318 14.3164L3.36865 16.8427",
    stroke: "#20242E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 189",
    d: "M16.8423 17.6836L19.3686 27.7889",
    stroke: "#20242E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredCheck);
export default __webpack_public_path__ + "static/media/ic-colored-check.0fdd39c903c7d8aa8af6cb992e62ea3f.svg";
export { ForwardRef as ReactComponent };